import React, { useEffect, useState, useRef } from "react";
import SubscriptionBottomSheet from "../components/SubscriptionBottomSheet";
import BottomNavigation from "../components/BottomNavigation";
import { obtenerPerfil, desvincularGoogle, vincularGoogle, eliminarCuenta, actualizarClavePerfil } from "../api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useGoogleLogin  } from '@react-oauth/google';
import { useAuth } from "../context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Perfil = () => {
    const [perfil, setPerfil] = useState(null);
    const [showChangePassword, setChangePassword] = useState(false);
    const navigate = useNavigate();
    const [precios, setPrecios] = useState({ inscripcion: 0, mensualidad: 0 });
    const [mostrarSheet, setMostrarSheet] = useState(false);
    const [loadingPerfil, setLoadingPerfil] = useState(true);
    const showSplash = useDynamicSplash(loadingPerfil);
    const { setUser,authReady, user } = useAuth();  

    const handleUpgradeClick = () => {
      setMostrarSheet(true);
    };
  
    const handleCloseSheet = () => {
      setMostrarSheet(false);
    };

    const handleContinue = (planSeleccionado) => {
      setMostrarSheet(false);
    };

    const confirmarEliminarCuenta = () => {
      toast((t) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <span>¿Estás seguro de que deseas eliminar tu cuenta? <br /><b>Todos tus datos serán eliminados y no podrás recuperarlos.</b></span>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button
              onClick={() => {
                toast.dismiss(t.id);
                ejecutarEliminacion();
              }}
              style={{
                backgroundColor: '#ff5c5c',
                color: '#fff',
                border: 'none',
                padding: '5px 10px',
                borderRadius: 5,
                fontSize: 14
              }}
            >
              Eliminar
            </button>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                border: '1px solid #ccc',
                padding: '5px 10px',
                borderRadius: 5,
                fontSize: 14
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      ), { duration: 10000 });
    };    

    const ejecutarEliminacion = async () => {
      const res = await eliminarCuenta(user.id);
      if (res.success) {
        localStorage.removeItem("userData");
        localStorage.removeItem("id_perfil");
        setUser(null);
        toast.dismiss();
        toast.success("Tu cuenta ha sido eliminada. ¡Gracias por formar parte de nuestra comunidad!");
        navigate("/", { replace: true });
      } else {
        toast.error(res.message || "No se pudo eliminar tu cuenta.");
      }
    };    

  const confirmarDesvincularGoogle = () => {
    toast((t) => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <span>¿Confirmas que deseas desvincular tu cuenta de Google?</span>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            onClick={() => {
              toast.dismiss(t.id);
              handleDesvincularGoogle();
            }}
            style={{
              backgroundColor: '#ff5c5c',
              color: '#fff',
              border: 'none',
              padding: '5px 10px',
              borderRadius: 5,
              fontSize: 14
            }}
          >
            Aceptar
          </button>
          <button
            onClick={() => toast.dismiss(t.id)}
            style={{
              border: '1px solid #ccc',
              padding: '5px 10px',
              borderRadius: 5,
              fontSize: 14
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    ), { duration: 10000 });
  };  

  const loginGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const accessToken = tokenResponse.access_token;
        const response = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
  
        const profile = await response.json();
  
        const res = await vincularGoogle(
          user.id,
          profile.sub,
          profile.email,
          profile.picture
        );
  
        if (res.success) {
          toast.dismiss();
            toast.success("Cuenta de Google vinculada correctamente.");
            setTimeout(() => {
                window.location.reload();
              }, 1000);
        } else {
          toast.dismiss();
          toast.error(res.error || "Error al vincular cuenta.");
        }
      } catch (err) {
        toast.dismiss();
        toast.error("Error inesperado al vincular Google.");
      }
    },
    onError: () => {
      toast.dismiss();
      toast.error("Error al iniciar sesión con Google.");
    },
    flow: "implicit",
    scope: "openid email profile",
  });
    

  const handleDesvincularGoogle = async () => {
    if (!user?.id) return;
  
    const res = await desvincularGoogle(user.id);
    if (res.success) {
      toast.dismiss();
        toast.success("Cuenta de Google desvinculada.");
        setTimeout(() => {
            window.location.reload();
          }, 1000);
    } else {
      toast.dismiss();
      toast.error(res.error || "No se pudo desvincular la cuenta.");
    }
  };

  useEffect(() => {
    if (!authReady) return;
    if (!user?.id) {
      navigate("/login", { replace: true });
    }
  }, [authReady, user]);
  
  /*useEffect(() => {
    if (!user || !user.id) return;
    const cargarPerfil = async () => {
      const data = await obtenerPerfil(user.id);
      if (data){
        setPerfil(data);
        setPrecios(data.precios);
        const timer = setTimeout(() => {
          setShowSplash(false);
          document.body.style.overflow = "auto";
          window.scrollTo(0, 0);
        }, 3000);
        return () => clearTimeout(timer);
      }
      else console.warn("No se pudo cargar el perfil.");
    };
    cargarPerfil();
  }, [user]);  */

  useEffect(() => {
    if (!user || !user.id) return;

    let mounted = true;
  
    const cargarPerfil = async () => {
      setLoadingPerfil(true);
      document.body.style.overflow = "hidden";
  
      try {
        const data = await obtenerPerfil(user.id);
        if (data) {
          setPerfil(data);
          setPrecios(data.precios);
        } else {
          console.warn("No se pudo cargar el perfil.");
        }
      } finally {
        if (mounted) {
          setLoadingPerfil(false);
          document.body.style.overflow = "auto";
        }
      }
    };
    cargarPerfil();
    return () => {
      mounted = false;
      document.body.style.overflow = "auto";
    };
  }, [user]);  

  useEffect(() => {
    const scrollGuardado = localStorage.getItem("scrollPerfil");
    if (scrollGuardado) {
      window.scrollTo(0, parseInt(scrollGuardado));
      localStorage.removeItem("scrollPerfil");
    }
  }, []);  

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("id_perfil");
    setUser(null);
    toast.dismiss();
    toast.success("Hasta luego. ¡Vuelve pronto!");
    navigate("/", { replace: true });
  };

  const irAActualizar = () => {
    localStorage.setItem("scrollPerfil", window.scrollY);
    navigate("/actualizardatos");
  };

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="promo-container">
        <div className={`promo-header`}>
        </div>
        <div className="promo-banner">
            <img src='../../assets/images/portada.jpg' alt="Portada" style={{borderRadius:0}}/>
        </div>
        <div className="promo-info" style={{padding: 0}}>
          <div className="profile-body" style={{width:'100%'}}>
            {perfil ? (
              <>
                <div className="user-profile-container">
                <img
                  src={
                    perfil.genero === "masculino"
                      ? "assets/images/masculino.png"
                      : perfil.genero === "femenino"
                      ? "assets/images/femenino.png"
                      : "assets/images/indefinido.png"
                  }
                  alt="Foto de perfil"
                />
                  <div>
                    <p className="user-profile-name">{perfil.nombre}</p>
                    <p className="user-profile-username">@{perfil.usuario}</p>
                  </div>
                </div>
                <div className="stats-container">
                  <div onClick={() => navigate("/seguidos")} className="stats-item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 12 12">
                          <path fill="currentColor" d="M4 8c2.044 0 3.766 1.48 3.997 3.442a.5.5 0 0 1-.994.116C6.833 10.108 5.544 9 4 9S1.167 10.108.997 11.558a.5.5 0 0 1-.994-.116C.234 9.48 1.956 8 4 8m0-6a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5m0 1a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m5.5-3a.5.5 0 0 1 .492.41L10 .5V2h1.5a.5.5 0 0 1 .492.41L12 2.5a.5.5 0 0 1-.5.5H10v1.5a.5.5 0 0 1-.992.09L9 4.5V3H7.5a.5.5 0 0 1-.492-.41L7 2.5a.5.5 0 0 1 .5-.5H9V.5a.5.5 0 0 1 .5-.5" />
                      </svg>
                      <span>{perfil.seguidos}</span>
                      <p>Seguidos</p>
                  </div>
                  <div onClick={() => navigate("/favoritos")} className="stats-item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M12 20.325q-.35 0-.712-.125t-.638-.4l-1.725-1.575q-2.65-2.425-4.788-4.812T2 8.15Q2 5.8 3.575 4.225T7.5 2.65q1.325 0 2.5.562t2 1.538q.825-.975 2-1.537t2.5-.563q2.35 0 3.925 1.575T22 8.15q0 2.875-2.125 5.275T15.05 18.25l-1.7 1.55q-.275.275-.637.4t-.713.125M11.05 6.75q-.725-1.025-1.55-1.563t-2-.537q-1.5 0-2.5 1t-1 2.5q0 1.3.925 2.763t2.213 2.837t2.65 2.575T12 18.3q.85-.775 2.213-1.975t2.65-2.575t2.212-2.837T20 8.15q0-1.5-1-2.5t-2.5-1q-1.175 0-2 .538T12.95 6.75q-.175.25-.425.375T12 7.25t-.525-.125t-.425-.375m.95 4.725" />
                      </svg>
                      <span>{perfil.favoritos}</span>
                      <p>Favoritos</p>
                  </div>
                  <div onClick={() => navigate("/chats")} className="stats-item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16"><path fill="currentColor" d="M6 7a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7m.5 1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM2 8a6 6 0 1 1 2.996 5.195l-2.338.78a.5.5 0 0 1-.639-.612l.712-2.491A6 6 0 0 1 2 8m6-5a5 5 0 0 0-4.3 7.552a.5.5 0 0 1 .05.393l-.509 1.78l1.658-.552a.5.5 0 0 1 .426.052A5 5 0 1 0 8 3"/></svg>
                      <span>{perfil.conexiones}</span>
                      <p>Conexiones</p>
                  </div>
              </div>
              {perfil && perfil.tipo === 10 ? (
              <div className="upgrade-card" onClick={handleUpgradeClick}>
                  <div className="left">
                      <div className="icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36">
                              <path fill="currentColor" d="M28 30H16v-8h-2v8H8v-8H6v8a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-8h-2Z" className="clr-i-outline clr-i-outline-path-1" />
                              <path fill="currentColor" d="m33.79 13.27l-4.08-8.16A2 2 0 0 0 27.92 4H8.08a2 2 0 0 0-1.79 1.11l-4.08 8.16a2 2 0 0 0-.21.9v3.08a2 2 0 0 0 .46 1.28A4.67 4.67 0 0 0 6 20.13a4.72 4.72 0 0 0 3-1.07a4.73 4.73 0 0 0 6 0a4.73 4.73 0 0 0 6 0a4.73 4.73 0 0 0 6 0a4.72 4.72 0 0 0 6.53-.52a2 2 0 0 0 .47-1.28v-3.09a2 2 0 0 0-.21-.9M30 18.13A2.68 2.68 0 0 1 27.82 17L27 15.88L26.19 17a2.71 2.71 0 0 1-4.37 0L21 15.88L20.19 17a2.71 2.71 0 0 1-4.37 0L15 15.88L14.19 17a2.71 2.71 0 0 1-4.37 0L9 15.88L8.18 17A2.68 2.68 0 0 1 6 18.13a2.64 2.64 0 0 1-2-.88v-3.08L8.08 6h19.84L32 14.16v3.06a2.67 2.67 0 0 1-2 .91" className="clr-i-outline clr-i-outline-path-2" />
                              <path fill="none" d="M0 0h36v36H0z" />
                          </svg>
                      </div>
                      <div>
                          <h3>¿Tienes un negocio?</h3>
                          <p>Publícalo y conéctate con miles de clientes que buscan lo que ofreces. <strong>Descubre más aquí.</strong></p>
                      </div>
                  </div>
              </div>
              ) : (
                <div className="spacer"></div>
              )}
              {mostrarSheet && (
                <SubscriptionBottomSheet
                  onClose={handleCloseSheet}
                  onContinue={handleContinue}
                  precios={precios}
                  id_perfil={perfil.id_perfil}
                />
              )}
              <div className="profile-details">
                  <p>
                      <span className="icon-container">
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                              <path fill="currentColor" d="M5 5h13a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 1c-.5 0-.94.17-1.28.47l7.78 5.03l7.78-5.03C18.94 6.17 18.5 6 18 6zm6.5 6.71L3.13 7.28C3.05 7.5 3 7.75 3 8v9a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V8c0-.25-.05-.5-.13-.72z" />
                          </svg>
                      </span>
                      <a href={`mailto:${perfil.correo}`}>{perfil.correo}</a>
                  </p>
                  <p>
                      <span className="icon-container">
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                              <path fill="currentColor" d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" />
                          </svg>
                      </span>
                      <a href={`tel:${perfil.telefono}`}>{perfil.telefono}</a>
                  </p>
                  <p>
                      <span className="icon-container">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 50 50">
                              <path fill="currentColor" d="m25 42.5l-.8-.9C23.7 41.1 12 27.3 12 19c0-7.2 5.8-13 13-13s13 5.8 13 13c0 8.3-11.7 22.1-12.2 22.7zM25 8c-6.1 0-11 4.9-11 11c0 6.4 8.4 17.2 11 20.4c2.6-3.2 11-14 11-20.4c0-6.1-4.9-11-11-11" />
                              <path fill="currentColor" d="M25 24c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5s-2.2 5-5 5m0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3" />
                          </svg>
                      </span>
                      Vives en {perfil.pais}
                      {perfil.pais === "Guatemala" && perfil.departamento ? ` (${perfil.departamento})` : ""}.
                  </p>
                  <p>
                      <span className="icon-container">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20">
                              <path fill="currentColor" d="M7 11a1 1 0 1 0 0-2a1 1 0 0 0 0 2m1 2a1 1 0 1 1-2 0a1 1 0 0 1 2 0m2-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m1 2a1 1 0 1 1-2 0a1 1 0 0 1 2 0m2-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m4-5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5zM4 7h12v7.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zm1.5-3h9A1.5 1.5 0 0 1 16 5.5V6H4v-.5A1.5 1.5 0 0 1 5.5 4" />
                          </svg>
                      </span>
                      Te uniste desde <b>{new Date(perfil.fecha_registro).toLocaleDateString('es-GT', { year: 'numeric', month: 'long' })}.</b>
                  </p>
                  <p>
                      <span className="icon-container">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 1 0-9-9c0 1.488.36 2.89 1 4.127L3 21l4.873-1c1.236.639 2.64 1 4.127 1" strokeWidth="1" />
                          </svg>
                      </span>
                      Haz realizado <b>{perfil.opiniones}</b> opiniones.
                  </p>
                  <p>
                      <span className="icon-container">
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                              <g fill="none" stroke="currentColor" strokeWidth="1">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M14.5 21v-5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v5" />
                                  <path d="M5 11v6c0 1.886 0 2.828.586 3.414S7.114 21 9 21h6c1.886 0 2.828 0 3.414-.586S19 18.886 19 17v-6M4.621 4.515c.182-.728.273-1.091.544-1.303C5.437 3 5.812 3 6.562 3h10.876c.75 0 1.125 0 1.397.212c.27.212.362.575.544 1.303l1.203 4.814c.097.388.146.581.135.739a1 1 0 0 1-.69.883c-.15.049-.354.049-.763.049c-.533 0-.8 0-1.023-.052a2 2 0 0 1-1.393-1.18c-.089-.212-.132-.47-.217-.983c-.024-.144-.036-.216-.05-.235a.1.1 0 0 0-.162 0c-.014.019-.026.09-.05.235l-.081.489l-.018.1A2 2 0 0 1 14.352 11h-.204a2 2 0 0 1-1.936-1.726l-.081-.49c-.024-.143-.036-.215-.05-.234a.1.1 0 0 0-.162 0c-.014.019-.026.09-.05.235l-.081.489l-.018.1A2 2 0 0 1 9.852 11h-.204A2 2 0 0 1 7.73 9.374l-.018-.1l-.081-.49c-.024-.143-.036-.215-.05-.234a.1.1 0 0 0-.162 0c-.014.019-.026.09-.05.235c-.085.514-.128.77-.217.983a2 2 0 0 1-1.392 1.18C5.536 11 5.27 11 4.736 11c-.409 0-.613 0-.763-.049a1 1 0 0 1-.69-.883c-.01-.158.038-.351.135-.739z" />
                              </g>
                          </svg>
                      </span>
                      Referiste a <b>{perfil.referidos}</b> tiendas.
                  </p>
              </div>
              <div className="settings-container">
                  <h2 className="settings-title">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                          <path fill="currentColor" d="M6 9.5A2 2 0 0 1 7.937 11H13.5a.5.5 0 0 1 .09.992L13.5 12l-5.563.001a2 2 0 0 1-3.874 0L2.5 12a.5.5 0 0 1-.09-.992L2.5 11h1.563A2 2 0 0 1 6 9.5m0 1a1 1 0 1 0 0 2a1 1 0 0 0 0-2m4-8A2 2 0 0 1 11.937 4H13.5a.5.5 0 0 1 .09.992L13.5 5l-1.563.001a2 2 0 0 1-3.874 0L2.5 5a.5.5 0 0 1-.09-.992L2.5 4h5.563A2 2 0 0 1 10 2.5m0 1a1 1 0 1 0 0 2a1 1 0 0 0 0-2" />
                      </svg>
                      Configuración
                  </h2>
                  <ul className="settings-list">
                      <li className="settings-item" onClick={() => irAActualizar()}>
                          <span>Actualizar datos personales</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                              <path fill="currentColor" d="m9.29 6.71l4.59 4.59l-4.59 4.59L10.7 17l6-6l-6-6z"/>
                          </svg>
                      </li>
                      <li className="settings-item" onClick={(e) => { e.preventDefault(); setChangePassword(true); }}>
                          <span>Actualizar contraseña</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                              <path fill="currentColor" d="m9.29 6.71l4.59 4.59l-4.59 4.59L10.7 17l6-6l-6-6z"/>
                          </svg>
                      </li>
                      <li className="settings-item" onClick={() => navigate("/terminos")}>
                          <span>Términos y Condiciones</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                              <path fill="currentColor" d="m9.29 6.71l4.59 4.59l-4.59 4.59L10.7 17l6-6l-6-6z"/>
                          </svg>
                      </li>
                      <li className="settings-item" onClick={() => navigate("/politicas")}>
                        <span>Políticas de Privacidad</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                          <path fill="currentColor" d="m9.29 6.71l4.59 4.59l-4.59 4.59L10.7 17l6-6l-6-6z"/>
                        </svg>
                      </li>
                      <li className="settings-item" onClick={confirmarEliminarCuenta}>
                          <span>Eliminar cuenta</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                              <path fill="currentColor" d="m9.29 6.71l4.59 4.59l-4.59 4.59L10.7 17l6-6l-6-6z"/>
                          </svg>
                      </li>
                  </ul>
              </div>
              <p className="delete-link" style={{textAlign:"center"}}>
                  <a onClick={handleLogout} href="#">
                      <svg style={{marginRight:3, verticalAlign:"sub"}} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M5 3h6a3 3 0 0 1 3 3v4h-1V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4h1v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3m3 9h11.25L16 8.75l.66-.75l4.5 4.5l-4.5 4.5l-.66-.75L19.25 13H8z" strokeWidth="0.7" stroke="currentColor" />
                      </svg>
                      Cerrar sesión
                  </a>
              </p>
              </>
            ) : (
              <p>Cargando perfil...</p>
            )}
          </div>
          <BottomNavigation />
          {showChangePassword && (
            <ChangePassword 
              onClose={() => setChangePassword(false)} 
              userId={perfil.id_perfil} 
            />
          )}
        </div>
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

const ChangePassword = ({ onClose, userId }) => {
  const [clave, setClave] = useState('');
  const [claveActual, setActual] = useState('');
  const [clave2, setClave2] = useState('');
  const [error, setError] = useState('');

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("overlay")) {
      onClose();
    }
  };
  
  const handleActualizarClave = async () => {
    if (claveActual.trim().length == 0) {
      setError('La contraseña actual es obligatoria.');
      return;
    }
    if (clave.trim().length < 4) {
      setError('La contraseña debe tener al menos 4 caracteres.');
      return;
    }
    if (clave !== clave2) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    const res = await actualizarClavePerfil(userId, claveActual, clave);

    if (!res.success) {
      toast.dismiss();
      toast.error(res.error || 'No se pudo actualizar la contraseña');
      return;
    }
    toast.dismiss();
    toast.success('Contraseña actualizada correctamente.');
    onClose();
  };

  return (
    <div className="overlay show" onClick={handleOverlayClick}>
      <div className="bottom-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
          <div className="step">
            <h2>Establece una nueva contraseña</h2>
            <input
              type="password"
              placeholder="Contraseña actual"
              value={claveActual}
              onChange={(e) => setActual(e.target.value)}
              className="input-style"
            />
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              className="input-style"
            />
            <input
              type="password"
              placeholder="Confirmar contraseña"
              value={clave2}
              onChange={(e) => setClave2(e.target.value)}
              className="input-style"
              style={{ marginTop: '10px' }}
            />
            {error && <p style={{ color: 'red', fontSize: '14px', paddingTop: 20 }}>{error}</p>}
            <div className="buttons">
              <button onClick={handleActualizarClave}>Finalizar</button>
            </div>
          </div>
      </div>
    </div>
  );
};

export default Perfil;
